interface RecordLimitBannerProps {
  recordsCount: number;
  maxRecordCount: number;
}

export function RecordLimitBanner({
  recordsCount,
  maxRecordCount,
}: RecordLimitBannerProps) {
  if (maxRecordCount === 0) return null;
  if (recordsCount < maxRecordCount) return null;

  return (
    <div
      role="status"
      className="mx-3 my-2 flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800 dark:border-amber-400/30 dark:bg-amber-950/60 dark:text-amber-200"
    >
      <span aria-hidden>⚠</span>
      <span>
        This project has reached its {recordsCount}/{maxRecordCount} photo
        limit. Delete photos or contact support to raise the limit.
      </span>
    </div>
  );
}
